export const environment = {
  production: true,
  sentryUrl: 'https://97b19015f16a409c9892bc1e08ae7bcc@sentry.happycake.co/5',
  keycloakUrl: 'https://auth.stand.happycake.info/auth',
  keycloakRealm: 'happy',
  keycloakClientId: 'profile-frontend',
  googleMapsApiKey: 'AIzaSyDPz9ZKroutn4O7Erujg1_TKGXR3hqsy08',
};
